import {gql} from '@apollo/client/core';
import {CartImageFragment} from "./cart-image-fragment";

export const ProductTagFragment = gql`
    fragment ProductTagFragment on ProductTag {
        id
        name
        translationTag
        order
        pdpDisplay
        mhpDisplay
        navDisplay
        landingDisplay
        plpFilterDisplay
        images {
            ...CartImageFragment
        }
        parent {
            id
            name
            translationTag
        }
    }

    ${CartImageFragment}
`;
